/**
 * DuplicateDocumentItem.js
 * Created by Ajit on 09/27/2021.
 */

import React from 'react';
import {useDispatch} from 'react-redux';
import {SVGICONS} from '@ey/icons';
import Button from '../BaseComponentWrappers/MotifButton';
import {labels} from '../../../util/utils';
import {selectDocumentOverwrite} from '../../../actions/Document/duplicatedocumentsactions';
import utility from '../../../util/utilityfunctions';
import styled from 'styled-components';
import EllipseControl from '../EllipsesControl/EllipsesControl';

function DuplicateDocumentItem({document, parentName}) {
	const dispatch = useDispatch();

	const setOverWrite = (value) => {
		dispatch(
			selectDocumentOverwrite(
				document.payload?.relatedEntityId || document.payload?.taskId,
				document.documentId,
				document.documentName,
				value,
				parentName
			)
		);
	};

	return (
		<StyledDuplicateDocumentItem key={document.documentId}>
			<SVGICONS
				styleName="large"
				name={utility.getDocumentExtension(document.docTypeId, document.documentName.split('.').pop())}
			/>
			<EllipseControl noOfLines={1} content={document.documentName} tooltip={document.documentName} />
			<span className="overwrite-buttons">
				<Button
					name="name"
					showLabel
					buttonLabel={labels.overwriteLabel}
					variant="secondary"
					className={document.isOverWrite ? 'active' : ''}
					disabled={false}
					onClick={() => setOverWrite(true)}
				/>
				<Button
					name="name"
					showLabel
					buttonLabel={labels.discardLabel}
					variant="secondary"
					className={document.isOverWrite ? '' : 'active'}
					disabled={false}
					onClick={() => setOverWrite(false)}
				/>
			</span>
		</StyledDuplicateDocumentItem>
	);
}

export default DuplicateDocumentItem;

const StyledDuplicateDocumentItem = styled.li`
	padding: var(--px-10) var(--px-5);
	font-size: var(--px-10);
	display: flex;
	border-top: var(--px-1) solid var(--neutrals-300);
	&:first-child {
		border-top: 0;
	}
	.ellipses {
		font-size: var(--px-14);
		width: 65%;
		margin-left: var(--px-5);
		margin-top: var(--px-3);
	}
	svg {
		margin-top: var(--px-3);
	}
	.overwrite-buttons {
		margin-left: auto;
		display: flex;
		button.motif-button-secondary {
			padding: var(--px-8) var(--px-10);
			height: var(--px-30);
			font-size: var(--px-14);
			margin-left: auto;
			&:first-child {
				margin-right: var(--px-16);
			}
			&:nth-child(2) {
				border-left: none;
			}
			&.active,
			&:hover {
				background: var(--neutrals-900);
				color: var(--neutrals-00white);
			}
		}
	}
`;
